import React from 'react'
import { BudgetFormProvider } from './hooks/use-budget-form'

import { BudgetViewV2Screen } from './pages'

export function BudgetViewV2() {
  return (
    <BudgetFormProvider>
      <BudgetViewV2Screen />
    </BudgetFormProvider>
  )
}
